import { render, staticRenderFns } from "./tab-base.vue?vue&type=template&id=48a2964d"
import script from "./tab-base.vue?vue&type=script&lang=js"
export * from "./tab-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports